module.exports = __webpack_public_path__ + "static/mo39-468f87b256b7237846f7d1b9ff1b74cd.png";